var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsString, MaxLength, MinLength } from 'class-validator';
/**
 * Body the widget posts to the public session-exchange endpoint. Carries only
 * the publishable key; the tenant-authorising origin is read from the
 * browser-supplied `Origin` header, which page JavaScript cannot forge.
 */
export class ExchangeEmbedSessionDto {
    embedKey;
}
__decorate([
    IsString(),
    MinLength(1),
    MaxLength(255),
    __metadata("design:type", String)
], ExchangeEmbedSessionDto.prototype, "embedKey", void 0);
//# sourceMappingURL=exchange-embed-session.dto.js.map